'use client'
import { usePathname } from "next/navigation"
import { useEffect } from "react"

const GENERATE_CLASSES = ['bg-[#F4F4F5]', 'dark:bg-[#121418]']

export default function BodyClassController() {
  const pathname = usePathname()

  useEffect(() => {
    const isGenerate = pathname.includes('generate')
    const { body } = document

    if (isGenerate) {
      body.classList.add(...GENERATE_CLASSES)
    } else {
      body.classList.remove(...GENERATE_CLASSES)
    }

    return () => {
      body.classList.remove(...GENERATE_CLASSES)
    }
  }, [pathname])

  return null
}
